import { Profile } from "../profile";
import lavender from "./images/mockups/issy-lavender.png";
import lavender_white from "./images/mockups/issy-lavender-white.png";
import lavender_1 from "./images/studio/issy-lavender-1.png";
import lavender_2 from "./images/studio/issy-lavender-2.png";
import sea_lavender from "./images/mockups/issy-sea-lavender.png";
import sea_lavender_white from "./images/mockups/issy-sea-lavender-white.png";
import sea_lavender_1 from "./images/studio/issy-sea-lavender-1.png";
import sea_lavender_2 from "./images/studio/issy-sea-lavender-2.png";
import sweet_pea from "./images/mockups/issy-sweet-pea.png";
import sweet_pea_white from "./images/mockups/issy-sweet-pea-white.png";
import sweet_pea_1 from "./images/studio/issy-sweet-pea-1.png";
import sweet_pea_2 from "./images/studio/issy-sweet-pea-2.png";
import process from "./images/studio/process.jpeg";

// Create the person first
const artist = new Profile("issy");
artist.insta = "id.artprints";
artist.description = `“I love printmaking because there is always an element of chance. Each print comes with its own quirks that make it completely unique. I’ve recently gotten into cyanotype, a traditional method of printing made from a chemical reaction to sunlight. In ‘Flowers in my Room’, I explore how nature shows up in my daily life; where nature is not only the subject, but an active participant in the process.”`;
artist.descriptionExtended = "TEST";

const details = `Original cyanotype on 320GSM cotton rag paper.
Made to order (please note that each print is unique and may differ to the picture).
Free UK postage only (Standard 5-10 working days).

Got a flower with meaning? Preserve it in a custom cyanotype print. Email for more details.`;

artist.createSection("flowers in my room.");

artist.createItem("lavender");
artist.setMockup(lavender);
artist.addImage(lavender_white);
artist.addImage(lavender_1);
artist.addImage(process);
artist.addImage(lavender_2);
artist.addSizeAndPrice("A4 (21x29.7cm)", 30, "price_1SUOz22LxEhI4RHCP4F8uaEi");
artist.setId("issy-lavender");
artist.addDetails(details);
artist.addTestPriceId("price_1SUOxv2LxEhI4RHCKeTv5Jty");
artist.addDescription(`"An original cyanotype print of a Lavender. Lavender represents purity, peace, and healing."`);

artist.createItem("sea-lavender");
artist.setMockup(sea_lavender);
artist.addImage(sea_lavender_white);
artist.addImage(sea_lavender_1);
artist.addImage(process);
artist.addImage(sea_lavender_2);
artist.addSizeAndPrice("A4 (21x29.7cm)", 30, "price_1SUOz52LxEhI4RHCAO32TlaB");
artist.setId("issy-sea-lavender");
artist.addDetails(details);
artist.addTestPriceId("price_1SUOy62LxEhI4RHCXQ7YpYOY");
artist.addDescription(`"An original cyanotype print of Sea Lavender. Sea Lavender represents endurance, grace and connection to the sea."`);

artist.createItem("sweet-pea");
artist.setMockup(sweet_pea);
artist.addImage(sweet_pea_white);
artist.addImage(sweet_pea_1);
artist.addImage(process);
artist.addImage(sweet_pea_2);
artist.addSizeAndPrice("A4 (21x29.7cm)", 30, "price_1SUOz72LxEhI4RHCW2oxNyP4");
artist.setId("issy-sweet-pea");
artist.addDetails(details);
artist.addTestPriceId("price_1SUOyH2LxEhI4RHCziYsCnNP");
artist.addDescription(`"An original cyanotype print of a Sweet Pea. Sweet Peas represent gratitutde, gentle affection and new beginnings."`);

export default artist;